import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { RegiaoSituacaoBadgeComponent } from './badge';
import { RegiaoSituacaoSelectComponent } from './select';
import { RegiaoSituacaoMultiselectComponent } from './multiselect';
import { RegiaoSituacaoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        RegiaoSituacaoSelectComponent,
        RegiaoSituacaoMultiselectComponent,
        RegiaoSituacaoBadgeComponent,

        // Pipes
        RegiaoSituacaoPipe
    ],
    exports: [
        RegiaoSituacaoSelectComponent,
        RegiaoSituacaoMultiselectComponent,
        RegiaoSituacaoBadgeComponent,

        // Pipes
        RegiaoSituacaoPipe
    ],
    providers: [
        // Pipes
        RegiaoSituacaoPipe
    ]
})
export class RegiaoSituacaoModule { }
